<template>
  <ItemView v-model="supply" @back="$router.go(-1)" @submit="handleSubmit" />
</template>

<script>
import { supplyFirebaseApi, SupplyModel } from '@/models/supplies.js'
import ItemView from '@/components/shared/ItemView.vue'

export default {
  name: 'CreateSupplyView',
  components: { ItemView },
  data () {
    return {
      supply: new SupplyModel()
    }
  },
  methods: {
    async handleSubmit () {
      const id = await supplyFirebaseApi.createSupply(this.supply)
      this.$router.push({ name: this.$strings.supplies.list.name })
    }
  }
}
</script>

<style lang="scss" scoped>
.supply-container {
  height: 100%;
  overflow: hidden;
  padding: 25px;

  .title {
    height: 10%;
    text-align: center;
    margin: 5px;
    font-size: 200%;
  }
  .supply-view {
    width: 100%;
    height: 80%;
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 10px;
    grid-auto-rows: minmax(100px, auto);

    .left-column {
      grid-column: 1;
      grid-row: 1;
    }
    .right-column {
      grid-column: 2;
      grid-row: 1;
      width: 100%;
    }
  }
  .submit-container {
    padding-top: 20px;
    height: 10%;
    width: 100%;

    .submit {
      color: var(--text-reverse);
      height: 90%;
      width: 100%;
      background: var(--accent-secondary);
      border-radius: 5px;
      filter: var(--add-depth);
    }
  }
}
</style>